import {
   mergeApplicationConfig,
   PLATFORM_ID,
   provideCheckNoChangesConfig,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

import { isPlatformBrowser } from '@angular/common';

const browserConfig = mergeApplicationConfig(appConfig, {
   providers: environment.production
      ? []
      : [
           provideCheckNoChangesConfig({
              exhaustive: true,
              interval: 10000,
           }),
        ],
});

bootstrapApplication(AppComponent, browserConfig)
   .then((appRef) => {
      const isBrowser = isPlatformBrowser(appRef.injector.get(PLATFORM_ID));

      if (isBrowser) {
         const scheduleNonCriticalSdkInit = (callback: () => void) => {
            const win = window as Window & {
               requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number;
            };
            const idle =
               win.requestIdleCallback ||
               ((cb: () => void) => window.setTimeout(cb, 1000));
            const runWhenUiIsIdle = () => {
               if (document.body.classList.contains('modal-open')) {
                  window.setTimeout(runWhenUiIsIdle, 5000);
                  return;
               }

               idle(callback, { timeout: 5000 });
            };
            const schedule = () => window.setTimeout(runWhenUiIsIdle, 15000);

            if (document.readyState === 'complete') {
               schedule();
            } else {
               window.addEventListener('load', schedule, { once: true });
            }
         };

         scheduleNonCriticalSdkInit(() => {
            // @ts-expect-error @moengage/web-sdk does not ship complete TypeScript declarations.
            import('@moengage/web-sdk')
               .then((moengageModule: any) => {
                  const moengage = moengageModule.default || moengageModule;
                  const win = window as Window & {
                     __musaffaMoengageInitialized?: boolean;
                  };
                  if (!win.__musaffaMoengageInitialized) {
                     moengage.initialize({
                        app_id: environment.moengageAppId,
                        cluster: 'DC_2',
                        debug_logs: environment.moengageDebugLogs,
                     });
                     win.__musaffaMoengageInitialized = true;
                  }
               })
               .catch((err: any) => console.error('MoEngage SDK failed to load', err));
         });
      }
   })
   .catch((err: any) => console.error(err));

// window.addEventListener('MOE_AUTOMATED_EVENTS', function (event: any) {
//    if (
//       event.detail.name === 'MOE_ONSITE_MESSAGE_CLICKED' &&
//       event.detail.data &&
//       event.detail.data.length
//    ) {
//       // console.log(event.detail.data);
//    }
// });
